import React from 'react';
import PropTypes from 'prop-types';
import { CSP_IDS, SERVICE_PROVIDERS } from '../constants';
import { loginHandler } from './LoginButton';

const logos = {
  [CSP_IDS.LOGIN_GOV]: (
    <img
      className="vads-sign-in-button__logo vads-sign-in-button__logo--logingov"
      src="/img/logingov-white.svg"
      alt="Login.gov"
    />
  ),
  [CSP_IDS.ID_ME]: (
    <img
      className="vads-sign-in-button__logo vads-sign-in-button__logo--idme"
      src="/img/idme.svg"
      alt="ID.me"
    />
  ),
  [CSP_IDS.CLEAR]: (
    <img
      className="vads-sign-in-button__logo vads-sign-in-button__logo--clear"
      src="/img/clear.svg"
      alt="CLEAR"
    />
  ),
  passkey: (
    <img
      className="vads-sign-in-button__logo vads-sign-in-button__logo--passkey"
      src="/img/FIDO_monochrome.svg"
      alt=""
    />
  ),
};

const labels = {
  [CSP_IDS.LOGIN_GOV]: SERVICE_PROVIDERS[CSP_IDS.LOGIN_GOV].label,
  [CSP_IDS.ID_ME]: SERVICE_PROVIDERS[CSP_IDS.ID_ME].label,
  [CSP_IDS.CLEAR]: 'Clear',
  passkey: 'passkey',
};

export function SignInButton({
  csp,
  onClick = loginHandler,
  useOAuth = true,
  ariaDescribedBy,
  actionLocation,
  queryParams = {},
  disabled = false,
  'data-dd-action-name': dataDdActionName = '',
  isPasskeyLoading = false,
}) {
  if (!csp) return null;
  const actionName =
    dataDdActionName || `${csp}-signin-button-${actionLocation}`;
  const logo = logos[csp];
  const label = 'Sign in with';
  const classes = `vads-sign-in-button vads-sign-in-button--${csp}`;
  const accessibleName = `${label} ${labels[csp]}`;

  const props = {
    type: 'button',
    'data-dd-action-name': actionName,
    className: classes,
    'data-csp': csp,
    'aria-label': accessibleName,
    onClick: () => onClick(csp, useOAuth, queryParams),
    'aria-describedby': ariaDescribedBy,
    disabled,
  };

  if (csp === 'passkey') {
    return (
      <button {...props}>
        <span className="vads-sign-in-button__label">
          {isPasskeyLoading ? 'Signing in with passkey...' : `${label} passkey`}
        </span>
        {logo}
      </button>
    );
  }

  if (csp === 'clear') {
    return (
      <button {...props}>
        <span className="vads-sign-in-button__label">{label}</span>
        <span className="vads-sign-in-button__lockup">{logo}</span>
      </button>
    );
  }

  return (
    <button {...props}>
      <span className="vads-sign-in-button__label">{label}</span>
      {logo}
    </button>
  );
}

export function VerifyButton({ csp, onClick }) {
  const logo = logos[csp];
  const label = 'Verify with';
  const classes = `vads-sign-in-button vads-sign-in-button--${csp}`;
  const accessibleName = `${label} ${labels[csp]}`;

  const props = {
    type: 'button',
    className: classes,
    'aria-label': accessibleName,
    onClick,
  };

  if (csp === 'clear') {
    return (
      <button {...props}>
        <span className="vads-sign-in-button__label">{label}</span>
        <span className="vads-sign-in-button__lockup">{logo}</span>
      </button>
    );
  }

  return (
    <button {...props}>
      <span className="vads-sign-in-button__label">{label}</span>
      {logo}
    </button>
  );
}

SignInButton.propTypes = {
  actionLocation: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  csp: PropTypes.string,
  'data-dd-action-name': PropTypes.string,
  disabled: PropTypes.bool,
  isPasskeyLoading: PropTypes.bool,
  queryParams: PropTypes.object,
  useOAuth: PropTypes.bool,
  onClick: PropTypes.func,
};

VerifyButton.propTypes = {
  csp: PropTypes.string,
  onClick: PropTypes.func,
};
